export const pdfType = 'pdf';
